module.exports = __webpack_public_path__ + "static/img/home_1.19a1b84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_1.jpg
// module id = h53b
// module chunks = 1